@if (backgroundOperationState.result(); as result) {
  <div
    animate.enter="overlay-fade-enter"
    animate.leave="overlay-fade-leave"
    class="fixed inset-0 z-70 flex items-center justify-center bg-black/60 transition-opacity duration-300"
    >
    <div animate.enter="panel-silk-enter" animate.leave="panel-silk-leave" class="bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-md w-full mx-4 transform transition-transform duration-300 scale-100">
      <div class="flex flex-col items-center justify-center px-8 pt-8 pb-6">
        <div
          class="mx-auto flex items-center justify-center h-16 w-16 rounded-full mb-4"
          [ngClass]="result.isError || result.colorProfile === 'red' ? 'bg-red-100' : 'bg-green-100'"
          >
          @if (!result.isError) {
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" [ngClass]="result.colorProfile === 'red' ? 'text-red-600' : 'text-green-600'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          }
          @if (result.isError) {
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
            </svg>
          }
        </div>
        <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-1">
          {{ result.title | transloco }}
        </h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 text-center mb-5">
          {{ result.message }}
        </p>
        @if (result.details?.length) {
          <div
            class="w-full bg-gray-50 dark:bg-gray-700 rounded-lg divide-y divide-gray-200 dark:divide-gray-600 mb-6 text-sm"
            >
            @for (detail of result.details; track detail) {
              <div class="flex justify-between px-4 py-2">
                <span class="text-gray-500 dark:text-gray-400">{{ detail.label | transloco }}</span>
                <span class="font-medium text-gray-900 dark:text-white">{{ detail.value }}</span>
              </div>
            }
          </div>
        }
        <button
          type="button"
          (click)="close()"
          class="bg-gray-600 hover:bg-gray-700 text-white text-sm font-medium py-2 px-6 rounded transition-colors duration-200"
          >
          {{ "Close" | transloco }}
        </button>
      </div>
    </div>
  </div>
}
